

import React, { PureComponent } from "react";
import styles from "./Result.scss";
import { t } from "../../../helpers/localization";
import AnimatedNumber from "react-animated-number";

export type Result_IProps = {
  result?: string;
  rating: number;
  ratingDelta: number;
  reward: number;
};

export const RESULTS = {
  WIN: 'WIN',
  DEFEAT: 'DEFEAT',
  DRAW: 'DRAW'
};

class Result extends PureComponent<Result_IProps> {


  getHighLightClass = () => {
    const result = this.props.result ? this.props.result : '';
    switch (result) {
      case RESULTS.WIN:
        {
          return styles.winHighlight;
        }

      case RESULTS.DEFEAT:
        {
          return styles.defeatHighlight;
        }

      case RESULTS.DRAW:
        {
          return styles.drawHighlight;
        }

      default:
        {
          return '';
        }

    }
  };

  render() {
    return <div className={styles.results}>
                <div className={`${styles.highlight} ${this.getHighLightClass()}`} />
                <span className={styles.resultsHeader}>{t('Получено за морское сражение')}</span>
                <div className={styles.resultSides}>
                    <div className={styles.resultSide}>
                        <div className={styles.resultRow}>
                            <span className={styles.resultValue}>{this.props.rating}</span>
                            <div className={styles.resultDelta}>
                                {'+'}
                                <AnimatedNumber component="span" value={this.props.ratingDelta ? this.props.ratingDelta : 0} duration={600} formatValue={n => parseInt(n)} />
                            </div>
                        </div>
                        <span className={styles.resultLabel}>{t('Рейтинг')}</span>
                    </div>
                    <div className={styles.resultSide}>
                        <div className={styles.resultRow}>
                            <span className={styles.resultValue}>{this.props.reward}</span>
                            <div className={styles.resultIcon} />
                        </div>
                        <span className={styles.resultLabel}>{t('Награда')}</span>
                    </div>
                </div>
            </div>;
  }
}

export default Result;